import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {new Date().getFullYear()} bankl. All rights reserved.</p>
        <div className="social-links">
          <a href="#" className="social-link">Twitter</a>
          <a href="#" className="social-link">Discord</a>
          <a href="#" className="social-link">GitHub</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;